import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Alert, Table} from "reactstrap";
import {
    FaArrowAltCircleRight,
    FaCloud,
    FaCreditCard,
    FaDatabase,
    FaDollarSign,
    FaShoppingCart, FaSyncAlt,
    FaUsers
} from "react-icons/fa";
import {Link} from "react-router-dom";
import axios from "axios";
import {Spinner} from "react-bootstrap";
import {Bar, Pie} from "react-chartjs-2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class AdminHome extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isNotification: '',
            textNotification: '',
            isStatisticalTop: true,
            errorTop: false,
            messageErrorTop: '',
            countOrderWaiting: 0,
            countRequestRecharge: 0,
            countNewUser: 0,
            countVpsWaiting: 0,
            countHostingWaiting: 0,
            countVpsExpire: 0,
            countHostingExpire: 0,
            //cost
            isStatisticalCost: true,
            errorCost: false,
            messageErrorCost: '',
            dataChartCost: {},
            statisticalCost: {},
            typeCost: 'this_week',
            typeCustomCost: 'day',
            startDateCost: new Date(),
            endDateCost: new Date(),
            isCustomCost: false,
            //service
            isStatisticalService: true,
            errorService: false,
            messageErrorService: '',
            dataChartService: {},
            statisticalService: {},
            //vps
            isStatisticalVps: true,
            errorVps: false,
            messageErrorVps: '',
            dataChartVps: {},
            typeVps: 'this_week',
            typeCustomVps: 'day',
            startDateVps: new Date(),
            endDateVps: new Date(),
            isCustomVps: false,
            //User
            isStatisticalUser: true,
            errorUser: false,
            messageErrorUser: '',
            dataChartUser: {},
            typeUser: 'this_week',
            typeCustomUser: 'day',
            startDateUser: new Date(),
            endDateUser: new Date(),
            isCustomUser: false,
            //Hosting
            isStatisticalHosting: true,
            errorHosting: false,
            messageErrorHosting: '',
            dataChartHosting: {},
            typeHosting: 'this_week',
            typeCustomHosting: 'day',
            startDateHosting: new Date(),
            endDateHosting: new Date(),
            isCustomHosting: false,
            is2Fa: false,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.querySelector('.cr-sidebar').classList.add('cr-sidebar--open');
        this.getContent();
        // if ( this.props.hosting ) {
        //     await this.loadStatisticalHosting();
        // }

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if (this.props.isNotification) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getContent = async () => {
        await this.loadStatisticalTop();
        await this.loadStatisticalCost();
        await this.loadStatisticalService();
        await this.loadStatisticalUser();
        if ( this.props.vps ) {
            await this.loadStatisticalVps();
        }
    }

    loadStatisticalTop = () => {
        this.setState({
            isStatisticalTop: true,
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/getStatisticalTop',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    // console.log("da xong loadStatisticalTop");
                    this.setState({
                        countOrderWaiting: ref.data.countOrderWaiting,
                        countRequestRecharge: ref.data.countRequestRecharge,
                        countNewUser: ref.data.countNewUser,
                        countVpsWaiting: ref.data.countVpsWaiting,
                        countHostingWaiting: ref.data.countHostingWaiting,
                        countVpsExpire: ref.data.countVpsExpire,
                        countHostingExpire: ref.data.countHostingExpire,
                        is2Fa: ref.data.is_2fa,
                        isStatisticalTop: false,
                    })

                    let item = {
                        agency_credit: ref.data.credit
                    }
                    this.props.updateAgencyCredit(item);
                } else {
                    if (ref.data.error > 9000) {
                        // console.log("da den 1");
                        this.props.logOut();
                    }
                    else {
                        this.setState({
                            errorTop: true,
                            messageErrorTop: ref.data.message,
                            isStatisticalTop: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isStatisticalTop: false,
                    errorTop: true,
                    messageErrorTop: 'Lấy dữ liệu thống kê thất bại',
                })
            })
    }

    /* Thống kê chi phí */
    loadStatisticalCost = () => {
        this.setState({
            isStatisticalCost: true,
            errorCost: false,
            messageErrorCost: '',
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let startDateCost = this.formatDateDatabase(this.state.startDateCost);
        let endDateCost = this.formatDateDatabase(this.state.endDateCost);

        let data = "?type=" + this.state.typeCost + "&typeCustom=" + this.state.typeCustomCost
            + "&startDate=" + startDateCost + "&endDate=" + endDateCost;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/getStatisticalCost' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    // console.log("da xong loadStatisticalCost");
                    let dataChartCost = {
                        labels: ['Nạp tiền', 'Tạo dịch vụ', 'Gia hạn', 'Nâng cấp'],
                        datasets: [
                            {
                                label: 'Biểu đồ thống kê chi phí',
                                data: [ ref.data.totalRecharge, ref.data.createService,
                                    ref.data.expireService, ref.data.upgradeServer ],
                                backgroundColor: [
                                    '#f56954',
                                    '#0000ff',
                                    '#00a65a',
                                    '#7200d0'
                                ],
                                borderWidth: 1,
                            },
                        ],
                    }

                    this.setState({
                        isStatisticalCost: false,
                        dataChartCost: dataChartCost,
                        statisticalCost: ref.data.statisticalCost
                    })
                } else {
                    if (ref.data.error > 9000) {
                        // console.log("da den 2");
                        this.props.logOut();
                    }
                    else {
                        this.setState({
                            errorCost: true,
                            messageErrorCost: ref.data.message,
                            isStatisticalCost: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isStatisticalCost: false,
                    errorCost: true,
                    messageErrorCost: 'Lấy dữ liệu thống kê thất bại',
                })
            })
    }

    btnStatisticalCost = async (type) => {
        if ( type !== 'custom' ) {
            await this.setState({
                typeCost: type
            })
            await this.loadStatisticalCost();
        }
        else {
            await this.setState({
                typeCost: type,
                isCustomCost: true
            })
        }
    }

    setStartDateCost = (date) => {
        this.setState({
            startDateCost: date
        })
    }

    setEndDateCost = (date) => {
        this.setState({
            endDateCost: date
        })
    }

    /* Thống kê dịch vụ */
    loadStatisticalService = () => {
        this.setState({
            isStatisticalService: true,
            errorService: false,
            messageErrorService: '',
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/getStatisticalService',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    // console.log("da xong loadStatisticalService");
                    this.setState({
                        isStatisticalService: false,
                        dataChartService: ref.data.dataChartService,
                        statisticalService: ref.data.statisticalService
                    })
                } else {
                    if (ref.data.error > 9000) {
                        // console.log("da den 3");
                        this.props.logOut();
                    }
                    else {
                        this.setState({
                            errorService: true,
                            messageErrorService: ref.data.message,
                            isStatisticalService: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isStatisticalService: false,
                    errorService: true,
                    messageErrorService: 'Lấy dữ liệu thống kê thất bại',
                })
            })
    }

    /* Thống kê User */
    loadStatisticalUser = () => {
        this.setState({
            isStatisticalUser: true,
            errorUser: false,
            messageErrorUser: '',
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let startDateUser = this.formatDateDatabase(this.state.startDateUser);
        let endDateUser = this.formatDateDatabase(this.state.endDateUser);

        let data = "?type=" + this.state.typeUser + "&typeCustom=" + this.state.typeCustomUser
            + "&startDate=" + startDateUser + "&endDate=" + endDateUser;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/getStatisticalUser' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    // console.log("da xong loadStatisticalUser");
                    this.setState({
                        isStatisticalUser: false,
                        dataChartUser: ref.data.dataChartUser,
                    })
                } else {
                    if (ref.data.error > 9000) {
                        // console.log("da den 4");
                        this.props.logOut();
                    }
                    else {
                        this.setState({
                            errorUser: true,
                            messageErrorUser: ref.data.message,
                            isStatisticalUser: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isStatisticalUser: false,
                    errorUser: true,
                    messageErrorUser: 'Lấy dữ liệu thống kê thất bại',
                })
            })
    }

    btnStatisticalUser = async (type) => {
        if ( type !== 'custom' ) {
            await this.setState({
                typeUser: type
            })
            await this.loadStatisticalUser();
        }
        else {
            await this.setState({
                typeUser: type,
                isCustomUser: true
            })
        }
    }

    setStartDateUser = (date) => {
        this.setState({
            startDateUser: date
        })
    }

    setEndDateUser = (date) => {
        this.setState({
            endDateUser: date
        })
    }

    btnSubmitCustomUser = () => {
        this.loadStatisticalUser();
    }

    /* Thống kê Vps */
    loadStatisticalVps = () => {
        this.setState({
            isStatisticalVps: true,
            errorVps: false,
            messageErrorVps: '',
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let startDateCost = this.formatDateDatabase(this.state.startDateVps);
        let endDateCost = this.formatDateDatabase(this.state.endDateVps);

        let data = "?type=" + this.state.typeVps + "&typeCustom=" + this.state.typeCustomVps
            + "&startDate=" + startDateCost + "&endDate=" + endDateCost;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/getStatisticalVps' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    // console.log("da xong loadStatisticalVps");
                    this.setState({
                        isStatisticalVps: false,
                        dataChartVps: ref.data.dataChartVps,
                    })
                } else {
                    if (ref.data.error > 9000) {
                        // console.log("da den 5");
                        this.props.logOut();
                    }
                    else {
                        this.setState({
                            errorVps: true,
                            messageErrorVps: ref.data.message,
                            isStatisticalVps: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isStatisticalVps: false,
                    errorVps: true,
                    messageErrorVps: 'Lấy dữ liệu thống kê thất bại',
                })
            })
    }

    btnStatisticalVps = async (type) => {
        if ( type !== 'custom' ) {
            await this.setState({
                typeVps: type
            })
            await this.loadStatisticalVps();
        }
        else {
            await this.setState({
                typeVps: type,
                isCustomVps: true
            })
        }
    }

    setStartDateVps = (date) => {
        this.setState({
            startDateVps: date
        })
    }

    setEndDateVps = (date) => {
        this.setState({
            endDateVps: date
        })
    }

    btnSubmitCustomVps = () => {
        this.loadStatisticalVps();
    }

    /* Thống kê Hosting */
    loadStatisticalHosting = () => {
        this.setState({
            isStatisticalHosting: true,
            errorHosting: false,
            messageErrorHosting: '',
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let startDateHosting = this.formatDateDatabase(this.state.startDateHosting);
        let endDateHosting = this.formatDateDatabase(this.state.endDateHosting);

        let data = "?type=" + this.state.typeHosting + "&typeCustom=" + this.state.typeCustomHosting
            + "&startDate=" + startDateHosting + "&endDate=" + endDateHosting;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/getStatisticalHosting' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    this.setState({
                        isStatisticalHosting: false,
                        dataChartHosting: ref.data.dataChartHosting,
                    })
                } else {
                    if (ref.data.error > 9000) {
                        // console.log("da den 6");
                        this.props.logOut();
                    }
                    else {
                        this.setState({
                            errorHosting: true,
                            messageErrorHosting: ref.data.message,
                            isStatisticalHosting: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isStatisticalHosting: false,
                    errorHosting: true,
                    messageErrorHosting: 'Lấy dữ liệu thống kê thất bại',
                })
            })
    }

    // btnStatisticalHosting = async (type) => {
    //     if ( type !== 'custom' ) {
    //         await this.setState({
    //             typeHosting: type
    //         })
    //         await this.loadStatisticalHosting();
    //     }
    //     else {
    //         await this.setState({
    //             typeHosting: type,
    //             isCustomHosting: true
    //         })
    //     }
    // }
    //
    // setStartDateHosting = (date) => {
    //     this.setState({
    //         startDateHosting: date
    //     })
    // }
    //
    // setEndDateHosting = (date) => {
    //     this.setState({
    //         endDateHosting: date
    //     })
    // }
    //
    // btnSubmitCustomHosting = () => {
    //     this.loadStatisticalHosting();
    // }

    formatDateDatabase = (date) => {
        var formatDate = new Date(date);
        var day = formatDate.getDate();
        if (day < 10) {
            day = '0' + day;
        }
        var month = date.getMonth() + 1;
        if (month < 10) {
            month = '0' + month;
        }
        return date.getFullYear()  + '-' + month + '-' + day;
    }

    btnSubmitCustomCost = () => {
        this.loadStatisticalCost();
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <>
                    <Alert color="success">
                        { this.state.textNotification }
                    </Alert>
                </>
            );
        }
        if ( this.state.errorNotification ) {
            return (
                <>
                    <Alert color="danger">
                        { this.state.messageErrorNotification }
                    </Alert>
                </>
            );
        }
        if ( this.state.successNotification ) {
            return (
                <>
                    <Alert color="success">
                        { this.state.messageSuccessNotification }
                    </Alert>
                </>
            );
        }
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    render() {
        return (
            <div className="py-4">
                <div className="title">
                    {
                        this.checkNotification()
                    }
                </div>
                <div className="row mb-4">
                    <div className="col-lg-3 col-6">
                        <div className="small-box bg-default">
                            {
                                this.state.isStatisticalTop ? (
                                    <div className="cr-page-spinner load-page">
                                        <Spinner animation="border" variant="primary"/>
                                    </div>
                                ) : (
                                    <>
                                        {
                                            this.state.errorTop ? (
                                                <>
                                                    <Alert color="danger">
                                                        { this.state.messageErrorTop }
                                                    </Alert>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="inner">
                                                        <h3>{ this.addCommas( this.props.agencyCredit ) } ₫</h3>
                                                        <p>Số dư tài khoản</p>
                                                    </div>
                                                    <div className="icon">
                                                        <FaDollarSign />
                                                    </div>
                                                    <Link to={'/admin/dai-ly/nap-tien.html'} className="small-box-footer text-dark">
                                                        <span className='mr-2'>Nạp tiền</span>
                                                        <FaArrowAltCircleRight />
                                                    </Link>
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </div>
                    </div>
                    {/*<div className="col-lg-3 col-6">*/}
                    {/*    <div className="small-box bg-default">*/}
                    {/*        {*/}
                    {/*            this.state.isStatisticalTop ? (*/}
                    {/*                <div className="cr-page-spinner load-page">*/}
                    {/*                    <Spinner animation="border" variant="primary"/>*/}
                    {/*                </div>*/}
                    {/*            ) : (*/}
                    {/*                <>*/}
                    {/*                    {*/}
                    {/*                        this.state.errorTop ? (*/}
                    {/*                            <>*/}
                    {/*                                <Alert color="danger">*/}
                    {/*                                    { this.state.messageErrorTop }*/}
                    {/*                                </Alert>*/}
                    {/*                            </>*/}
                    {/*                        ) : (*/}
                    {/*                            <>*/}
                    {/*                                <div className="inner">*/}
                    {/*                                    {*/}
                    {/*                                        this.state.is2Fa ? (*/}
                    {/*                                            <h3>Đã cài đặt</h3>*/}
                    {/*                                        ) : (*/}
                    {/*                                            <h3 className="danger-progressing">Chưa cài đặt</h3>*/}
                    {/*                                        )*/}
                    {/*                                    }*/}
                    {/*                                    <p className="text-danger font-weight-bold">Xác thực 2 yếu tố</p>*/}
                    {/*                                </div>*/}
                    {/*                                <div className="icon">*/}
                    {/*                                    <FaLock />*/}
                    {/*                                </div>*/}
                    {/*                                {*/}
                    {/*                                    this.state.is2Fa ? (*/}
                    {/*                                        <Link to={'/admin/dai-ly/tat-xac-thuc-2-yeu-to.html'} className="small-box-footer text-dark">*/}
                    {/*                                            <span className='mr-2'>Tắt cài đặt</span>*/}
                    {/*                                            <FaArrowAltCircleRight />*/}
                    {/*                                        </Link>*/}
                    {/*                                    ) : (*/}
                    {/*                                        <Link to={'/admin/dai-ly/cai-dat-xac-thuc-2-yeu-to.html'} className="small-box-footer text-dark">*/}
                    {/*                                            <span className='mr-2'>Cài đặt</span>*/}
                    {/*                                            <FaArrowAltCircleRight />*/}
                    {/*                                        </Link>*/}
                    {/*                                    )*/}
                    {/*                                }*/}
                    {/*                            </>*/}
                    {/*                        )*/}
                    {/*                    }*/}
                    {/*                </>*/}
                    {/*            )*/}
                    {/*        }*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="col-lg-3 col-6">
                        <div className="small-box bg-warning">
                            {
                                this.state.isStatisticalTop ? (
                                    <div className="cr-page-spinner load-page">
                                        <Spinner animation="border" variant="primary"/>
                                    </div>
                                ) : (
                                    <>
                                        {
                                            this.state.errorTop ? (
                                                <>
                                                    <Alert color="danger">
                                                        { this.state.messageErrorTop }
                                                    </Alert>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="inner">
                                                        <h3>{ this.state.countOrderWaiting }</h3>
                                                        <p>Thanh toán chờ</p>
                                                    </div>
                                                    <div className="icon">
                                                        <FaShoppingCart />
                                                    </div>
                                                    <Link to={'/admin/don-dat-hang/don-dat-hang-cho.html'} className="small-box-footer text-dark">
                                                        <span className='mr-2'>Chi tiết</span>
                                                        <FaArrowAltCircleRight />
                                                    </Link>
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </div>
                    </div>
                    <div className="col-lg-3 col-6">
                        <div className="small-box bg-info">
                            {
                                this.state.isStatisticalTop ? (
                                    <div className="cr-page-spinner load-page">
                                        <Spinner animation="border" variant="primary"/>
                                    </div>
                                ) : (
                                    <>
                                        {
                                            this.state.errorTop ? (
                                                <>
                                                    <Alert color="danger">
                                                        { this.state.messageErrorTop }
                                                    </Alert>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="inner">
                                                        <h3>{ this.state.countRequestRecharge }</h3>
                                                        <p>Yêu cầu nạp tiền mới</p>
                                                    </div>
                                                    <div className="icon">
                                                        <FaCreditCard />
                                                    </div>
                                                    <Link to={'/admin/quan-ly-giao-dich/nap-tien-tai-khoan.html'} className="small-box-footer">
                                                        <span className='mr-2'>Chi tiết</span>
                                                        <FaArrowAltCircleRight />
                                                    </Link>
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </div>
                    </div>
                    <div className="col-lg-3 col-6">
                        <div className="small-box bg-primary">
                            {
                                this.state.isStatisticalTop ? (
                                    <div className="cr-page-spinner load-page">
                                        <Spinner animation="border" variant="primary"/>
                                    </div>
                                ) : (
                                    <>
                                        {
                                            this.state.errorTop ? (
                                                <>
                                                    <Alert color="danger">
                                                        { this.state.messageErrorTop }
                                                    </Alert>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="inner">
                                                        <h3>{ this.state.countNewUser }</h3>
                                                        <p>Khách hàng mới</p>
                                                    </div>
                                                    <div className="icon">
                                                        <FaUsers />
                                                    </div>
                                                    <Link to={'/admin/khach-hang'} className="small-box-footer text-dark">
                                                        <span className='mr-2'>Chi tiết</span>
                                                        <FaArrowAltCircleRight />
                                                    </Link>
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </div>
                    </div>
                    {
                        this.props.vps ? (
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-success">
                                    {
                                        this.state.isStatisticalTop ? (
                                            <div className="cr-page-spinner load-page">
                                                <Spinner animation="border" variant="primary"/>
                                            </div>
                                        ) : (
                                            <>
                                                {
                                                    this.state.errorTop ? (
                                                        <>
                                                            <Alert color="danger">
                                                                { this.state.messageErrorTop }
                                                            </Alert>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="inner">
                                                                <h3>{ this.state.countVpsWaiting }</h3>
                                                                <p>VPS chờ tạo</p>
                                                            </div>
                                                            <div className="icon">
                                                                <FaCloud />
                                                            </div>
                                                            <Link to={'/admin/vps/danh-sach-vps-cho-tao.html'} className="small-box-footer text-dark">
                                                                <span className='mr-2'>Chi tiết</span>
                                                                <FaArrowAltCircleRight />
                                                            </Link>
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.hosting ? (
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-info">
                                    {
                                        this.state.isStatisticalTop ? (
                                            <div className="cr-page-spinner load-page">
                                                <Spinner animation="border" variant="primary"/>
                                            </div>
                                        ) : (
                                            <>
                                                {
                                                    this.state.errorTop ? (
                                                        <>
                                                            <Alert color="danger">
                                                                { this.state.messageErrorTop }
                                                            </Alert>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="inner">
                                                                <h3>{ this.state.countHostingWaiting }</h3>
                                                                <p>Hosting chờ tạo</p>
                                                            </div>
                                                            <div className="icon">
                                                                <FaDatabase />
                                                            </div>
                                                            <Link to={'/admin/hosting/danh-sach-hosting-cho-tao.html'} className="small-box-footer text-dark">
                                                                <span className='mr-2'>Chi tiết</span>
                                                                <FaArrowAltCircleRight />
                                                            </Link>
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.vps ? (
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-danger">
                                    {
                                        this.state.isStatisticalTop ? (
                                            <div className="cr-page-spinner load-page">
                                                <Spinner animation="border" variant="primary"/>
                                            </div>
                                        ) : (
                                            <>
                                                {
                                                    this.state.errorTop ? (
                                                        <>
                                                            <Alert color="danger">
                                                                { this.state.messageErrorTop }
                                                            </Alert>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="inner">
                                                                <h3>{ this.state.countVpsExpire }</h3>
                                                                <p>VPS hết hạn</p>
                                                            </div>
                                                            <div className="icon">
                                                                <FaCloud />
                                                            </div>
                                                            <Link to={'/admin/vps/danh-sach-vps-het-han.html'} className="small-box-footer text-dark">
                                                                <span className='mr-2'>Chi tiết</span>
                                                                <FaArrowAltCircleRight />
                                                            </Link>
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.hosting ? (
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-secondary">
                                    {
                                        this.state.isStatisticalTop ? (
                                            <div className="cr-page-spinner load-page">
                                                <Spinner animation="border" variant="primary"/>
                                            </div>
                                        ) : (
                                            <>
                                                {
                                                    this.state.errorTop ? (
                                                        <>
                                                            <Alert color="danger">
                                                                { this.state.messageErrorTop }
                                                            </Alert>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="inner">
                                                                <h3>{ this.state.countHostingExpire }</h3>
                                                                <p>Hosting hết hạn</p>
                                                            </div>
                                                            <div className="icon">
                                                                <FaDatabase />
                                                            </div>
                                                            <Link to={'/admin/hosting/danh-sach-hosting-het-han.html'} className="small-box-footer text-dark">
                                                                <span className='mr-2'>Chi tiết</span>
                                                                <FaArrowAltCircleRight />
                                                            </Link>
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        ) : (
                            <></>
                        )
                    }
                    <div className="col-md-12">
                        <div className="card card-info">
                            <div className="card-header">
                                <h3 className="card-title">Thống kê chi phí</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    {
                                        this.state.isStatisticalCost ? (
                                            <div className="cr-page-spinner load-page">
                                                <Spinner animation="border" variant="primary"/>
                                            </div>
                                        ) : (
                                            <>
                                                {
                                                    this.state.errorCost ? (
                                                        <>
                                                            <Alert color="danger">
                                                                { this.state.messageErrorCost }
                                                            </Alert>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="col-md-6 mb-4">
                                                                <Pie data={ this.state.dataChartCost } />
                                                            </div>
                                                            <div className="col-md-6 mb-4">
                                                                <Table className="table table-bordered table-hover">
                                                                    <thead className="primary">
                                                                    <tr>
                                                                        <th>Loại</th>
                                                                        <th>Tổng cộng</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {
                                                                        this.state.statisticalCost.map( (statistical, key) => (
                                                                            <tr key={key}>
                                                                                <td>{ statistical.title }</td>
                                                                                <td>{ this.addCommas(statistical.value) } ₫</td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                    <div className="col-md-12">
                                        <button type="button" className="btn btn-danger mr-1" onClick={ () => this.btnStatisticalCost('last_week') }>
                                            Tuần trước
                                        </button>
                                        <button type="button" className="btn btn-danger mr-1" onClick={ () => this.btnStatisticalCost('last_month') }>
                                            Tháng trước
                                        </button>
                                        <button type="button" className="btn btn-primary mr-1" onClick={ () => this.btnStatisticalCost('this_week') }>
                                            Tuần này
                                        </button>
                                        <button type="button" className="btn btn-primary mr-1" onClick={ () => this.btnStatisticalCost('this_month') }>
                                            Tháng này
                                        </button>
                                        <button type="button" className="btn btn-success mr-1" onClick={ () => this.btnStatisticalCost('custom') }>
                                            Tùy chọn
                                        </button>
                                        <div className="col-md-12 row mt-4">
                                            {
                                                this.state.isCustomCost ? (
                                                    <>
                                                        <div className="form-group col-md-4">
                                                            <label>Từ ngày</label>
                                                            <DatePicker
                                                                selected={this.state.startDateCost}
                                                                onChange={(date) => this.setStartDateCost(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Đến ngày ngày</label>
                                                            <DatePicker
                                                                selected={this.state.endDateCost}
                                                                onChange={(date) => this.setEndDateCost(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className="form-group col-md-4 btn_custom_statistical">
                                                            <button className="btn btn-primary" onClick={ () => this.btnSubmitCustomCost() }>
                                                                <FaSyncAlt /> Xác nhận
                                                            </button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="card card-success">
                            <div className="card-header">
                                <h3 className="card-title">Thống kê dịch vụ</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    {
                                        this.state.isStatisticalService ? (
                                            <div className="cr-page-spinner load-page">
                                                <Spinner animation="border" variant="primary"/>
                                            </div>
                                        ) : (
                                            <>
                                                {
                                                    this.state.errorService ? (
                                                        <>
                                                            <Alert color="danger">
                                                                { this.state.messageErrorService }
                                                            </Alert>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="col-md-6 mb-4">
                                                                <Pie data={ this.state.dataChartService } />
                                                            </div>
                                                            <div className="col-md-6 mb-4 table-responsive">
                                                                <Table className="table table-bordered table-hover">
                                                                    <thead className="primary">
                                                                    <tr>
                                                                        <th>Loại</th>
                                                                        <th>Tổng cộng</th>
                                                                        <th>Đang sử dụng</th>
                                                                        <th>Hết hạn</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {
                                                                        this.state.statisticalService.map( (statistical, key) => (
                                                                            <tr key={key}>
                                                                                <td>{ statistical.title }</td>
                                                                                <td>{ this.addCommas(statistical.total) }</td>
                                                                                <td>{ this.addCommas(statistical.using) }</td>
                                                                                <td>{ this.addCommas(statistical.expire) }</td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title">Thống kê khách hàng tạo mới</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    {
                                        this.state.isStatisticalUser ? (
                                            <div className="cr-page-spinner load-page">
                                                <Spinner animation="border" variant="primary"/>
                                            </div>
                                        ) : (
                                            <>
                                                {
                                                    this.state.errorUser ? (
                                                        <>
                                                            <Alert color="danger">
                                                                { this.state.messageErrorUser }
                                                            </Alert>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="col-md-12 mb-4">
                                                                <Bar data={ this.state.dataChartUser } />
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                    <div className="col-md-12">
                                        <button type="button" className="btn btn-danger mr-1" onClick={ () => this.btnStatisticalUser('last_week') }>
                                            Tuần trước
                                        </button>
                                        <button type="button" className="btn btn-danger mr-1" onClick={ () => this.btnStatisticalUser('last_month') }>
                                            Tháng trước
                                        </button>
                                        <button type="button" className="btn btn-primary mr-1" onClick={ () => this.btnStatisticalUser('this_week') }>
                                            Tuần này
                                        </button>
                                        <button type="button" className="btn btn-primary mr-1" onClick={ () => this.btnStatisticalUser('this_month') }>
                                            Tháng này
                                        </button>
                                        <button type="button" className="btn btn-success mr-1" onClick={ () => this.btnStatisticalUser('custom') }>
                                            Tùy chọn
                                        </button>
                                        <div className="col-md-12 row mt-4">
                                            {
                                                this.state.isCustomUser ? (
                                                    <>
                                                        <div className="form-group col-md-4">
                                                            <label>Từ ngày</label>
                                                            <DatePicker
                                                                selected={this.state.startDateUser}
                                                                onChange={(date) => this.setStartDateUser(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Đến ngày ngày</label>
                                                            <DatePicker
                                                                selected={this.state.endDateUser}
                                                                onChange={(date) => this.setEndDateUser(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className="form-group col-md-4 btn_custom_statistical">
                                                            <button className="btn btn-primary" onClick={ () => this.btnSubmitCustomUser() }>
                                                                <FaSyncAlt /> Xác nhận
                                                            </button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        this.props.vps ? (
                            <div className="col-md-12">
                                <div className="card card-danger">
                                    <div className="card-header">
                                        <h3 className="card-title">Thống kê VPS</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            {
                                                this.state.isStatisticalVps ? (
                                                    <div className="cr-page-spinner load-page">
                                                        <Spinner animation="border" variant="primary"/>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {
                                                            this.state.errorVps ? (
                                                                <>
                                                                    <Alert color="danger">
                                                                        { this.state.messageErrorVps }
                                                                    </Alert>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="col-md-12 mb-4">
                                                                        <Bar data={ this.state.dataChartVps } />
                                                                    </div>
                                                                </>
                                                            )
                                                        }
                                                    </>
                                                )
                                            }
                                            <div className="col-md-12">
                                                <button type="button" className="btn btn-danger mr-1" onClick={ () => this.btnStatisticalVps('last_week') }>
                                                    Tuần trước
                                                </button>
                                                <button type="button" className="btn btn-danger mr-1" onClick={ () => this.btnStatisticalVps('last_month') }>
                                                    Tháng trước
                                                </button>
                                                <button type="button" className="btn btn-primary mr-1" onClick={ () => this.btnStatisticalVps('this_week') }>
                                                    Tuần này
                                                </button>
                                                <button type="button" className="btn btn-primary mr-1" onClick={ () => this.btnStatisticalVps('this_month') }>
                                                    Tháng này
                                                </button>
                                                <button type="button" className="btn btn-success mr-1" onClick={ () => this.btnStatisticalVps('custom') }>
                                                    Tùy chọn
                                                </button>
                                                <div className="col-md-12 row mt-4">
                                                    {
                                                        this.state.isCustomVps ? (
                                                            <>
                                                                <div className="form-group col-md-4">
                                                                    <label>Từ ngày</label>
                                                                    <DatePicker
                                                                        selected={this.state.startDateVps}
                                                                        onChange={(date) => this.setStartDateVps(date)}
                                                                        dateFormat="dd/MM/yyyy"
                                                                        className="form-control"
                                                                    />
                                                                </div>
                                                                <div className="form-group col-md-4">
                                                                    <label>Đến ngày ngày</label>
                                                                    <DatePicker
                                                                        selected={this.state.endDateVps}
                                                                        onChange={(date) => this.setEndDateVps(date)}
                                                                        dateFormat="dd/MM/yyyy"
                                                                        className="form-control"
                                                                    />
                                                                </div>
                                                                <div className="form-group col-md-4 btn_custom_statistical">
                                                                    <button className="btn btn-primary" onClick={ () => this.btnSubmitCustomVps() }>
                                                                        <FaSyncAlt /> Xác nhận
                                                                    </button>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <></>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <></>
                        )
                    }
                    {/*{*/}
                    {/*    this.props.vps ? (*/}
                    {/*        <div className="col-md-12">*/}
                    {/*            <div className="card card-warning">*/}
                    {/*                <div className="card-header">*/}
                    {/*                    <h3 className="card-title">Thống kê Hosting</h3>*/}
                    {/*                </div>*/}
                    {/*                <div className="card-body">*/}
                    {/*                    <div className="row">*/}
                    {/*                        {*/}
                    {/*                            this.state.isStatisticalHosting ? (*/}
                    {/*                                <div className="cr-page-spinner load-page">*/}
                    {/*                                    <Spinner animation="border" variant="primary"/>*/}
                    {/*                                </div>*/}
                    {/*                            ) : (*/}
                    {/*                                <>*/}
                    {/*                                    {*/}
                    {/*                                        this.state.errorHosting ? (*/}
                    {/*                                            <>*/}
                    {/*                                                <Alert color="danger">*/}
                    {/*                                                    { this.state.messageErrorHosting }*/}
                    {/*                                                </Alert>*/}
                    {/*                                            </>*/}
                    {/*                                        ) : (*/}
                    {/*                                            <>*/}
                    {/*                                                <div className="col-md-12 mb-4">*/}
                    {/*                                                    <Bar data={ this.state.dataChartHosting } />*/}
                    {/*                                                </div>*/}
                    {/*                                            </>*/}
                    {/*                                        )*/}
                    {/*                                    }*/}
                    {/*                                </>*/}
                    {/*                            )*/}
                    {/*                        }*/}
                    {/*                        <div className="col-md-12">*/}
                    {/*                            <button type="button" className="btn btn-danger mr-1" onClick={ () => this.btnStatisticalHosting('last_week') }>*/}
                    {/*                                Tuần trước*/}
                    {/*                            </button>*/}
                    {/*                            <button type="button" className="btn btn-danger mr-1" onClick={ () => this.btnStatisticalHosting('last_month') }>*/}
                    {/*                                Tháng trước*/}
                    {/*                            </button>*/}
                    {/*                            <button type="button" className="btn btn-primary mr-1" onClick={ () => this.btnStatisticalHosting('this_week') }>*/}
                    {/*                                Tuần này*/}
                    {/*                            </button>*/}
                    {/*                            <button type="button" className="btn btn-primary mr-1" onClick={ () => this.btnStatisticalHosting('this_month') }>*/}
                    {/*                                Tháng này*/}
                    {/*                            </button>*/}
                    {/*                            <button type="button" className="btn btn-success mr-1" onClick={ () => this.btnStatisticalHosting('custom') }>*/}
                    {/*                                Tùy chọn*/}
                    {/*                            </button>*/}
                    {/*                            <div className="col-md-12 row mt-4">*/}
                    {/*                                {*/}
                    {/*                                    this.state.isCustomHosting ? (*/}
                    {/*                                        <>*/}
                    {/*                                            <div className="form-group col-md-4">*/}
                    {/*                                                <label>Từ ngày</label>*/}
                    {/*                                                <DatePicker*/}
                    {/*                                                    selected={this.state.startDateHosting}*/}
                    {/*                                                    onChange={(date) => this.setStartDateVps(date)}*/}
                    {/*                                                    dateFormat="dd/MM/yyyy"*/}
                    {/*                                                    className="form-control"*/}
                    {/*                                                />*/}
                    {/*                                            </div>*/}
                    {/*                                            <div className="form-group col-md-4">*/}
                    {/*                                                <label>Đến ngày ngày</label>*/}
                    {/*                                                <DatePicker*/}
                    {/*                                                    selected={this.state.endDateVps}*/}
                    {/*                                                    onChange={(date) => this.setEndDateHosting(date)}*/}
                    {/*                                                    dateFormat="dd/MM/yyyy"*/}
                    {/*                                                    className="form-control"*/}
                    {/*                                                />*/}
                    {/*                                            </div>*/}
                    {/*                                            <div className="form-group col-md-4 btn_custom_statistical">*/}
                    {/*                                                <button className="btn btn-primary" onClick={ () => this.btnSubmitCustomHosting() }>*/}
                    {/*                                                    <FaSyncAlt /> Xác nhận*/}
                    {/*                                                </button>*/}
                    {/*                                            </div>*/}
                    {/*                                        </>*/}
                    {/*                                    ) : (*/}
                    {/*                                        <></>*/}
                    {/*                                    )*/}
                    {/*                                }*/}
                    {/*                            </div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    ) : (*/}
                    {/*        <></>*/}
                    {/*    )*/}
                    {/*}*/}
                </div>
                <input type="hidden" id="page" value="admin-home"/>
                <input type="hidden" id="token" value={this.props.token} />
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        popup: state.adminMain.popup,
        agencyCredit: state.agency.agency_credit,
        vps: state.system.vps,
        cloudServer: state.system.cloudServer,
        hosting: state.system.hosting,
        vps_us: state.system.vps_us,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminHome' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateAgencyCredit: (item) => {
            dispatch(({ type : 'updateAgencyCredit', item }))
        },
        updatePopup: (item) => {
            dispatch(({ type : 'updatePopup', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminHome);